import React, { useState, useEffect } from 'react';
import { Table, Button, Tooltip } from 'antd';
import { ColumnToggle, TableFilters } from './Modules';
import './index.scss';


const EaseTable = (props) => {
    const getColumns = (columns) => {
        return columns.map((column) => {
            let thisColumn = { ...column }
            if (!thisColumn.hasOwnProperty('visible')) thisColumn.visible = true;
            if (thisColumn.hasOwnProperty('width')) thisColumn.width = column.width;
            if (thisColumn.sortable) {
                thisColumn['sorter'] = true;
                thisColumn['sortDirections'] = ['descend', 'ascend'];
            }
            return thisColumn;
        })
    };

    const getDefaultFilters = (filterNodes) => {
        const filters = {};
        filterNodes.forEach(filterNode => filters[filterNode.field] = filterNode.defaultValue);
        return filters;
    };

    const [tableInfo, setTableInfo] = useState({
        pagination: props.pagination,
        filters: getDefaultFilters(props.filterNodes),
        selectedColumns: getColumns(props.columns)
    });
    const [selectedRows, setSelectedRows] = useState(props.selectedRows);

    const rowSelection = () => {
        return {
            // fixed: props.fixedSelectable,
            fixed: false,
            selectedRowKeys: selectedRows.map(x => x[props.rowKey]),
            onChange: (selectedRowKeys, selectedRows) => {
                setSelectedRows(selectedRows);
                props.handleRowSelection(selectedRows);
            },
            getCheckboxProps: (record) => ({                
                disabled: props.disabledCheckboxProps(record),// Column configuration not to be checked
            }),
        }
    };

    const setColumnVisibility = (selectedColumns) => {
        tableInfo.selectedColumns = selectedColumns;
        setTableInfo({ ...tableInfo });
        props.handleTableChange({ ...tableInfo, trigger: "columns" });
    };

    const handlePaginationChange = (pagination) => {
        tableInfo.pagination = pagination;
        setTableInfo({ ...tableInfo });
        props.handleTableChange({ ...tableInfo, trigger: "pagination" });
    };

    const handleFiltersChange = (values) => {
        tableInfo.filters = values;
        setTableInfo({ ...tableInfo });
        props.handleTableChange({ ...tableInfo, trigger: "filters" });
    };

    const renderColumnSelection = () => {
        if (!props.columnToggle) { return null; }
        return <ColumnToggle
            isEnabled={props.columnToggle}
            columns={tableInfo.selectedColumns}
            onChange={setColumnVisibility}
        />
    };

    const renderReload = () => {
        if (!props.reloadable) { return null; }
        return (
            <Tooltip title={props.reloadText}>
                <Button
                    onClick={() => props.onReload(tableInfo)}
                    icon="reload"
                    size="default"
                    className={`reload-btn ${props.reloadClass} lms-color-success`}
                />
            </Tooltip>
        )
    };

    const renderFilters = () => {
        if (props.filterNodes.length < 1) { return null; }
        return (
            <TableFilters
                filterNodes={props.filterNodes}
                handleFiltersChange={handleFiltersChange}
                appliedFilters={tableInfo.filters}
                downloadable={props.downloadable}
                onDownload={props.onDownload}
                isDownloading={props.isDownloading}
                data={props.data}
                enableSettlementMappingReport={props.enableSettlementMappingReport}
                onSettlementMappingDownload={props.onSettlementMappingDownload}
                isSettlementMappingDownloading={props.isSettlementMappingDownloading}
            />
        )
    };

    useEffect(() => {
        setTableInfo({...tableInfo, selectedColumns: getColumns(props.columns)})
    }, [props.columns]);

    useEffect(() => {
        setSelectedRows(props.selectedRows)
    }, [props.selectedRows]);

    useEffect(() => {
        const filters = {};
        props.filterNodes.forEach(filterNode => filters[filterNode.field] = tableInfo.filters[filterNode.field] || filterNode.defaultValue);
        setTableInfo({...tableInfo, filters: filters})
    }, [props.filterNodes]);

    return (
        <div className={`ease-table-wrapper ${props.scrollX ? 'scrollable' : ''} ${props.striped ? 'ease-striped-table' : ''}`}>
            {
                props.columnToggle || props.reloadable ? (
                    <div className="d-flex justify-content-between mb-2 p-1 flex-wrap">
                        <div>
                            {renderColumnSelection()}
                        </div>
                        <div className="d-flex justify-content-end">
                            <div className="ml-2">
                                {renderReload()}
                            </div>
                        </div>
                    </div>
                ) : null
            }
            <div className="d-flex justify-content-between mb-2 p-1 flex-wrap">
                        <div>
                            {renderColumnSelection()}
                        </div>
                        <div className="d-flex justify-content-end">
                            <div className="ml-2">
                                {renderReload()}
                            </div>
                        </div>
                    </div>
            {renderFilters()}
            <Table
                size={props.size}
                className={props.className}
                loading={props.loading}
                bordered={props.bordered}
                rowSelection={props.selectable ? rowSelection() : null}
                rowKey={record => record[`${props.rowKey}`]}
                rowClassName={(row, index) => { return (index % 2 === 0) ? `et-row even-row ${props.evenRowClassName}` : `et-row odd-row ${props.oddRowClassName}` }}
                dataSource={props.data}
                scroll={{ x: props.scrollX , y:props.scrollY}}
                title={props.title ? props.title : null}
                columns={(tableInfo.selectedColumns || []).filter((x) => { return x.visible })}
                onChange={handlePaginationChange}
                pagination={tableInfo.pagination && props.totalRecords ? { ...tableInfo.pagination, total: props.totalRecords } : false}
                locale={{ emptyText: props.emptyText }}
                onRow={props.onRow}
            />
        </div>
    );
}

EaseTable.defaultProps = {
    bordered: false,
    columnToggle: false,
    loading: false,
    scrollX: false,
    fixedSelectable: true,
    striped: true,
    data: [],
    columns: [],
    pagination: {},
    size: "small",
    reloadable: false,
    reloadText: "Reload",
    reloadClass: "",
    className: "",
    oddRowClassName: "",
    evenRowClassName: "",
    emptyText: undefined,
    filterNodes: [],
    selectedRows:[],
    downloadable: false,
    isDownloading: false,
    onReload: () => { },
    handleTableChange: () => { },
    handleRowSelection: () => { },
    handleColumnSelection: () => { },
    onRow: () => { },
    onDownload: () => { },
    disabledCheckboxProps: () => { },
};

export { EaseTable };